<template>
    <DFormRow
        :label="control.label"
        :is-required="control.isRequired"
        :error="control.errors?.[0]"
        class="mb-3"
    >
        <div
            v-if="isBoolean && !isString"
            class="d-block mb-2"
        >
            <DSwitch
                :id="control.id"
                v-model="control.data"
                color="success"
                variant="3d"
                @update:checked="onInput"
            />
        </div>
        <DSelect
            v-else-if="isEnum"
            :id="control.id"
            v-model="control.data"
            :options="enumOptions"
            :is-valid="!control.errors?.length"
            @update:value="onInput"
        />
        <DFormTextarea
            v-else-if="isString && control.uischema.options?.type === 'textarea'"
            :id="control.id"
            v-model="control.data"
            :placeholder="control.label"
            :is-valid="!control.errors?.length"
            :aria-rowcount="control.uischema.options?.rows"
            @update:modelValue="onInput"
        />
        <DInput
            v-else
            :id="control.id"
            v-model="control.data"
            :placeholder="control.label"
            :is-valid="!control.errors?.length"
            @update:value="onInput"
        />
        <span
            v-if="!!control.description"
            class="d-block small mt-1 text-muted"
        >
            {{ control.description }}
        </span>
    </DFormRow>
</template>

<script setup>
import { rendererProps, useJsonFormsControl } from '@jsonforms/vue'
import { computed } from 'vue'
import { isBooleanControl, isEnumControl, isStringControl } from '@jsonforms/core'

const props = defineProps(rendererProps())

const { control, handleChange } = useJsonFormsControl(props)

const isBoolean = computed(() =>
    isBooleanControl(props.uischema, props.schema)
)

const isEnum = computed(() =>
    isEnumControl(props.uischema, props.schema)
)

const isString = computed(() =>
    isStringControl(props.uischema, props.schema) && !isEnum.value
)

const enumOptions = computed(() => {
    const values = control.value.schema.enum ?? []

    return values.map((val) => ({
        label: val,
        value: val
    }))
})

function onInput (val) {
    handleChange(control.value.path, val)
}
</script>
